import { Component, OnInit } from '@angular/core';
import {ApiService} from '../services/api.service';
import {LoaderService} from '../shared/loader/loader-service.services';
import {UtilService} from '../services/UtilService';

@Component({
  selector: 'app-iboxx-news-page',
  templateUrl: './iboxx-news-page.component.html',
  styleUrls: ['./iboxx-news-page.component.scss']
})
export class IboxxNewsPageComponent implements OnInit {

  newsDocument: string[] = [];
  newsHeading: string[] = [];

  constructor(private apiService: ApiService, private loader: LoaderService, private utilService: UtilService) {
  }

  ngOnInit(): void {
    this.loader.show();
    this.apiService.getS3Objects().subscribe((resp: any) => {
      this.newsDocument = resp;
      this.newsHeading = [... new Set(this.newsDocument.map((doc: any) => doc.split('/')[0]))];
      this.loader.hide();
    });
  }

  openNewsDocument(documentName: string): void{
    if (documentName.includes('pdf')) {
      this.apiService.getPDFFileFromS3(documentName).subscribe((resp: any) => {
        const file = new Blob([resp], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_newtab');
      });
    }else{
      this.apiService.getTextFileFromS3(documentName).subscribe((resp: any) => {
        console.log(resp);
      });
    }
  }

}
